// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import {
  CreditCalculations
} from './CreditCalculations'

import {
  CreditCalculationsConsolidation
} from './CreditCalculationsConsolidation'


export const Calculations = ({ creditApplication, client, updateCredit, updateCreditApplication, refetchData, onClick, open, userHasOverrideResponsibility }) => (
  creditApplication.creditType === 'CONSOLIDATION'
    ? <CreditCalculationsConsolidation
        client={client}
        creditApplication={creditApplication}
        assignedToIdentityId={creditApplication.assignedTo.id}
        saveLoan={updateCredit}
        creditType={creditApplication.creditType}
        updateCreditApplication={updateCreditApplication}
        open={open}
        refetchData={refetchData}
        onClick={onClick}
        userHasOverrideResponsibility={userHasOverrideResponsibility}
        updatedBy={creditApplication.updatedBy}
        overrideBy={creditApplication.overrideBy}
        overrideAt={creditApplication.overrideAt}
        amountEligibleFor={creditApplication.amountEligibleFor}
      />
    : <CreditCalculations
        client={client}
        creditApplication={creditApplication}
        saveLoan={updateCredit}
        creditType={creditApplication.creditType}
        updateCreditApplication={updateCreditApplication}
        calculationsLocked={creditApplication.locked}
        calculationsSnapshot={creditApplication.calculationsCamelcase}
        open={open}
        onClick={onClick}
        userHasOverrideResponsibility={userHasOverrideResponsibility}
      />
)

Calculations.propTypes = {
  creditApplication: PropTypes.shape({
    amountAppliedFor: PropTypes.string,
    repaymentMaxApplied: PropTypes.string,
    borrowableMax: PropTypes.string,
    productBorrowableActual: PropTypes.string,
    eligibleLoanAmount: PropTypes.string,
    eligibleLowerDescription: PropTypes.string,
    warningUnevenDeductions: PropTypes.string,
    updatedBy: PropTypes.shape({
      id: PropTypes.string.isRequired,
      identity: PropTypes.shape({
        id: PropTypes.string.isRequired,
        fullName: PropTypes.string.isRequired
      })
    }).isRequired,
    overrideBy: PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired
    }),
    overrideAt: PropTypes.string,
    creditType: PropTypes.string.isRequired
  }).isRequired,
  client: PropTypes.shape({
    payrollcycle: PropTypes.shape({
      cycle: PropTypes.string
    })
  }).isRequired,
  updateCredit: PropTypes.func.isRequired,
  updateCreditApplication: PropTypes.func.isRequired,
  refetchData: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  userHasOverrideResponsibility: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/creditapplication-modal/Calculations.js